import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { SegmentationContextMenuItem } from '../../components/SegmentationContextMenuItem';
import { ISegmentationOrderBl } from '../../segmentationsOrder.Bl';

interface IProps {
  onMenuClose(): void;
  segmentationId: string;
}

export const BringToFrontContextMenuItemContainer = observer((props: IProps): ReactElement => {
  const segmentationOrderBl = useInjection(ISegmentationOrderBl.$);

  const handleAction = (): void => {
    segmentationOrderBl.bringSegmentationToFront(props.segmentationId);
  };

  return (
    <SegmentationContextMenuItem
      {...props}
      text='bring_to_front'
      icon='bring-front-icon'
      action={handleAction}
    />
  );
});
